import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/header'
import { Box } from "@mui/material";
import { Tabs as MuiTabs } from "@mui/material";
import { Tab } from "@mui/material";
import { ExpandMore } from "@material-ui/icons";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@material-ui/core";
import ReactGA from 'react-ga'
import InstituteTabs from "../components/institutiontabs";
import '../css/programs-page.css'
import Footer from '../components/footer';
import cardImg from '../images/programs/choose your uni.svg'
import cardImg1 from '../images/programs/start online.svg'
import cardImg2 from '../images/programs/get your visa.svg'
import cardImg3 from '../images/programs/completed overseas.svg'
import unismarterImage1 from '../images/programs/one program many outcomes.svg'
import unismarterImage2 from '../images/programs/felxibility all the way.svg'
import unismarterImage3 from '../images/programs/rupee saved.svg'
import unismarterImage4 from '../images/programs/save time and trouble.svg'
import bussinessImag from '../images/programs/Business.png'
import commerseImag from '../images/programs/Commerce.png'
import computerImage from '../images/programs/ComputerScience.png'
import marketingImage from '../images/programs/Marketing.png'
import sportsImage from '../images/programs/Sports.png'
import hospitalityImage from '../images/programs/hospaitality&tourism.png'
import sampleOfferImage from '../images/programs/sample offer letter.png'
import { graphql, Link } from "gatsby";
import { TabPanel, Tabs } from 'react-tabs';
import "../css/sharan-style.css";
import "../css/animate.min.css";
import "../css/style.css";
import UniversityCardView from '../components/UniversityCardView';
import PartnerUniversities from '../components/partner-universities';
import UnismarterPartnerUniversitiesSlider from '../components/UnismarterPartnerUniversitiesSlider';
import { BsFillCircleFill } from 'react-icons/bs';
import AmericanDreamRequirements from '../components/AmericanDreamRequirements';
import FaqSection from '../components/FAQSection';
import UniSmarterFaqSection from '../components/UniSmarterFaqSection';

const Unismarter = (wpUniData) => {

    const uniArr = wpUniData.data.allWordpressWpUniversities.nodes
    
    const [value, setValue] = React.useState(0);
    const [cardData, setCardData] = useState([
        {
            image: cardImg, title: "Choose Your University", text: "Get admission to your preferred university from Australia, the United Kingdom or Dubai and receive your offer letter*"
        },
        {
            image: cardImg1, title: "Start Online", text: "Complete the first year of your degree online in just 3.5 months (2 modules in 7 weeks)  without any delays thanks to multiple intakes (intake every 2 months)."
        },
        {
            image: cardImg2, title: "Get Your Visa", text: "Complete your visa process while studying and be ready to go overseas by the end of the UniSmarter program."
        },
        {
            image: cardImg3, title: "Complete Overseas", text: "Progress to the overseas campus to complete the remainder of your degree and apply for post study work rights."
        }
    ])
    const [coursesGridData, setCoursesGridData] = useState([
        {
            image: bussinessImag, text: "Business & Analytics", gridR: "1/2", gridC: "1/2",gridRM:'1/2',gridCM:'1/4'
        },
        {
            image: commerseImag, text: "Commerce & finance", gridR: "1/2", gridC: "2/3",gridRM:'2/3',gridCM:'1/4'
        },
        {
            image: computerImage, text: "Computer Science & Information Technology", gridR: "1/2", gridC: "3/4",gridRM:'3/4',gridCM:'1/4'
        },
        {
            image: marketingImage, text: "Marketing", gridR: "2/3", gridC: "1/2",gridRM:'4/5',gridCM:'1/4'
        },
        {
            image: sportsImage, text: "Sports and Events Management", gridR: "2/3", gridC: "2/3",gridRM:'5/6',gridCM:'1/4'
        },
        {
            image: hospitalityImage, text: "Hospitality and Tourism", gridR: "2/3", gridC: "3/4",gridRM:'6/7',gridCM:'1/4'
        },
    ])
    const [collapse, setCollapse] = useState([
        {
            title: "Accounting for Business Management",
            body: "Numbers are everything! This module gives the students a compendious information about accounting & finance and its practical use cases in the business world. Students receive basic and fundamental knowledge required to analyse and interpret financial statements that will directly impact the crucial decision making process to meet the business objectives."
        },
        {
            title: "Principles of Marketing",
            body: "Marketing is creating relationships with the customer and the business. From this module students will gain knowledge about the concepts, techniques and practical examples of marketing used by marketers to develop products and create campaigns which will help increase the sales of the product. It will also help students understand how to identify target markets and audience, customer data segmentation and creation of communication strategies for different channels to drive demand and growth."
        },
        {
            title: "Writing & Research for Business & Commerce",
            body: "Writing & Research are two critical aspects of academic and professional skills. The module includes development of proficiencient foundation skills which include critical thinking, time management, use of language, presenting and supporting arguments, creating reports and visualisation of data which are important for a successful professional career in business and commerce."
        },
        {
            title: "Introduction to Statistics",
            body: "Statistics is a very important aspect of mathematics. It involves calculation, analysis and interpretation alongwith with presentation of information and data which can use in different fields like social sciences, business and more. The module establishes a strong understanding of statistical practices, data analysis techniques along with the use of different tools which help in implementation of different methods of analysis. The module covers study designs, data manipulation, statistical inference, regression and analysis of categorical data."
        }

    ])

    const [collapse2,setCollapse2]=useState([
        {
            title:"Writing and Research for Science & Engineering",
            body:"Writing & Research are two critical aspects of academic and professional skills. This module guides the students to build and develop blueprints, analyse and present scientific arguments. Students will also learn to engage with scientific literature by developing skills of critical thinking, time management, interpretation of visual data, presenting and supporting arguments."
        },
        {
            title:"Principles of Business Information",
            body:"Business Information Systems is the backbone of any organization for leading to efficient operations and management of the business.The module builds foundational knowledge of the students in understanding the content of Information Systems; overview of Information Systems, job opportunities in different organizations, business impact on Information Systems. Students also get to explore the different tools, techniques and frameworks used to build Information Systems."
        },
        {
            title:"Introduction to Programming",
            body:"The most important language needed to have a successful career in technology is programming language. This module creates basic programming understanding for the students to excel in academics and their future professions. Students get to learn fundamentals of programming concepts, programming languages (Java) which help develop interactive UI/UX theoretically and practically."
        },
        {
            title:"Introduction to Statistics",
            body:"Statistics is a very important aspect of mathematics. It involves calculation, analysis and interpretation alongwith with presentation of information and data which can be used in different fields like social sciences, business and more.The module establishes a strong understanding of statistical practices, data analysis techniques along with the use of different tools which help in implementation of different methods of analysis. The module covers study designs, data manipulation, statistical inference, regression and analysis of categorical data."
        },
    ])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="program-page" style={{fontFamily: "caros"}}>
            <Helmet>
                <title>
                    The UniSmarter | The WorldGrad
                </title>
                <meta
                    name="description"
                    content="Get answers to all your study abroad questions on topics like  like, program options to choose from, pros and cons of different countries, student visa application process, how to finance your overseas education, most value for money universities, entry requirement to get into a good university and much more in The WorldGrad study resources section." />
                <meta
                    name="keywords"
                    content="study abroad, study overseas, educations courses, student visas, universities" />
                <link rel="icon" href="https://res.cloudinary.com/worldgrad/image/upload/v1612961357/worldgrad/twg_favicon_ymgrbw.png" />

            </Helmet>
            <Header />
            <div className="container-fluid american-dream-banner-section-unismarter mt-md-3 d-flex justify-content-center align-items-center">
                <div className="row">
                    {/* <div> */}
                        <div className="col-12 ">
                            <p className='text-muted american-dream-breadcrumb'>
                                Programs - <p className='american-dream-breadcrumb-alt'> UniSmarter </p> 
                            </p>
                        </div>
                        <div className="col-12">
                            <h1 className='text-center' style={{color: "#fff"}}>
                                UniSmarter Program
                            </h1>
                        </div>
                        <div className="col-12">
                            <h5 className='text-center pt-md-4 american-dream-banner-subtext'>
                                Fast-track your overseas education at a world-class university with the UniSmarter program 
                            </h5>
                        </div>
                    {/* </div> */}
                </div>
            </div>

            <div className="section py-5" style={{backgroundColor: "#fff"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h4 className='american-dream-section-one-heading' style={{textTransform: "uppercase"}}>
                                Start online with UniSmarter program and complete your degree from top ranked universities across the globe  
                            </h4>
                        </div>
                        <div className="col-12">
                            <h6 className='american-dream-section-one-subtext'>
                                UniSmarter is an online program that allows students to complete a part of their first year, i.e. 4 modules online from home before progressing to one of our overseas partner institutions in Australia, the UK or the UAE to complete the rest of the degree, giving them flexibility and optionality to choose their career path.
                            </h6>
                        </div>
                    </div>
                </div>
            </div>

            <section style={{backgroundColor: "#f8f8fa"}}>
                <div className="container py-5">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h3>
                                Our Program Partner
                            </h3>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-around px-md-5">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Unismarter-by-Navitas.png" alt=""
                            class="img-fluid mb-3 d-flex mx-auto shadow p-1"
                            style={{ borderRadius: "15px", width: "250px" }}
                        />
                    </div>
                </div>
            </section>

            <section style={{backgroundColor: "#fff"}}>
                <div className="container pt-5 pb-5 pb-md-0">
                    <div className="row">
                        <div className="col-12 text-center mb-4">
                            <h3> The WorldGrad Journey </h3>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-md-4">
                            <div className="col-12">
                                <a href='/unismarter'>
                                    <h5 className='worldgrad-journey-heading' style={{ color: "#FCB017"}}>
                                        Year 1 (Term 1) - UniSmarter Program
                                    </h5>
                                </a>
                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'>
                                    Program Provider - The WorldGrad
                                </h6>
                                <img className='react-icon-arrow-desktop-alt' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                                <h6 className='worldgrad-journey-content'>
                                    Study Mode - Online
                                </h6>
                                <img className='react-icon-arrow-phone' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="col-12">
                                {/* <a href="/americandream"> */}
                                    <h5 className='worldgrad-journey-heading'>
                                        Year 1 (Term 2) - Diploma 
                                    </h5>
                                {/* </a> */}
                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'>
                                    Program Provider - Top Ranked University College
                                </h6>
                                <img className='react-icon-arrow-desktop-alt' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                                <h6 className='worldgrad-journey-content'>
                                    Study Mode - On Campus
                                </h6>
                                <img className='react-icon-arrow-phone' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="col-12">
                                <h5 className='worldgrad-journey-heading'> Year 2,3  - Bachelor Degree </h5>
                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'> Course Provider - Top Ranked University </h6>
                                <h6 className='worldgrad-journey-content'> Study Mode - On Campus </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="american-dream-card-section py-5">
                <div className="container">
                    <div className="row mb-3">
                        <div className="col-12 text-center">
                            <h3 style={{lineHeight: "40px"}}>Why Is UniSmarter The Right Choice For You?</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage1} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> One Program, Many Outcomes(icons) </h5>
                                            <p classname="american-dream-card-text">
                                                Still undecided? Not a problem. Change your course preference to any of our partner institutions anytime during your studies 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage2} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Flexibility All The Way </h5>
                                            <p classname="american-dream-card-text">
                                                Attend classes by international faculty during Indian time zones and get individual tutor support available 7 days a week
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage3} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> A Rupee Saved Is A Rupee Earned </h5>
                                            <p classname="american-dream-card-text">
                                                Complete the first semester (4 modules) at roughly 30% the on-campus cost with UniSmarter. Moreover, save 6 months of living expenses by starting online 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage4} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Save Time And Trouble </h5>
                                            <p classname="american-dream-card-text">
                                                No IELTS or Visa required to start the program. Start right away while you prepare to move overseas
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='container-fluid american-dream-top-courses py-5'>
                <div className="row mb-2 mb-md-4">
                    <div className="col-12">
                        <h3 className='text-center'> Top Courses Through UniSmarter Program </h3>
                    </div>
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}>Bachelor Of Computer Science</h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Eynesbury College/ University Of Adelaide
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 3 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/university-of-adelaide/ug/bachelor-of-computer-science/"
                            // href={course.course_link}
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
                <div className="row mb-2 mb-md-4">
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}>Bachelor Of Commerce
                        </h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Griffith College/ Griffith University
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 3 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/edith-cowan-university/ug/bachelor-of-commerce/"
                            // href={course.course_link}
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
                <div className="row mb-2 mb-md-0">
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}> BSc In International Business</h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Brunel University College/ Brunel University London
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 3 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/united-kingdom/brunel-university-london/ug/b-sc-in-international-business/"
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
            </div>

            <div className="collapse-section py-5">
                <div className="collapse-section-text-area">
                    <span className="collapse-section-text-area-title">What will you study?</span>
                    <h6 className='american-dream-section-one-subtext px-3'>
                        Based on your degree choice you will study the following modules over the course of the UniSmarter program before progressing overseas to your country and course of choice.
                    </h6>
                </div>
                <div className="placerholder-accordion">

                    <Accordion className="customize-accord" defaultExpanded={false}>
                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title" >
                        Business/ Management/ Commerce/ Finance/ Marketing
                            {/* Computer Science/Information Technology */}
                        </AccordionSummary>

                        <AccordionDetails className="customize-accord-body">
                            {
                                collapse.map((e, i) => (
                                    <Accordion defaultExpanded={false} className="customise-accord-color customize-accord">
                                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title-title">
                                            {e.title}
                                        </AccordionSummary>

                                        <AccordionDetails className="customize-accord-body-body">
                                            {e.body}
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            }

                        </AccordionDetails>
                    </Accordion>

                    <Accordion className="customize-accord" defaultExpanded={false}>
                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title" >
                        Computer Science/ Information Technology
                        </AccordionSummary>

                        <AccordionDetails className="customize-accord-body">
                            {
                                collapse2.map((e, i) => (
                                    <Accordion key={i} defaultExpanded={true} className="customise-accord-color customize-accord">
                                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title-title">
                                            {e.title}
                                        </AccordionSummary>

                                        <AccordionDetails className="customize-accord-body-body">
                                            {e.body}
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            }

                        </AccordionDetails>
                    </Accordion>

                </div>
            </div>
            
            <AmericanDreamRequirements 
                QualificationInfo={["All India School Certificate (CBSE): Successful completion of AISSCE with an overall GPA starting from 50% or above", "India Higher Secondary School Certificate (State Boards): Average starting from 50% or above"]}
                EnglishRequirements={["IELTS score starting from 5.5 (or equivalent)", "TOEFL score starting from 72 or equivalent"]}
                FeesAndScholarship={["INR 3,24,000 + GST (INR 81,000 + GST per module)", "University Fees starting from AUD 28,922 per annum*", "Scholarships up to AUD 20,000 per annum*"]}
                imgFile="https://media.publit.io/file/TheWorldgrad/9Programs/UniSmarterProgram/sample-offer-letter-_NEW-2.jpg"
                imgHeading="Sample Offer Letter"
            />

            <section className="py-5" style={{backgroundColor: "#f8f8fa"}}> 
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="text-center"> FAQs </h3>
                        </div>
                    </div>
                </div>
                {/* <FaqSection /> */}
                <UniSmarterFaqSection />
            </section>
            <Footer />
        </div>
    )
}

export default Unismarter

export const WorldGradUniversities = graphql `
    {
        allWordpressWpUniversities {
            nodes {
              id
              slug
              title
              acf {
                banner_image {
                  source_url
                }
                country
              }
            }
        }
    }
`


